import { render } from "./FireVehicleCard.vue?vue&type=template&id=8e4f6bcc&scoped=true"
import script from "./FireVehicleCard.vue?vue&type=script&lang=ts"
export * from "./FireVehicleCard.vue?vue&type=script&lang=ts"

import "./FireVehicleCard.vue?vue&type=style&index=0&id=8e4f6bcc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8e4f6bcc"

export default script